var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinorStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.40505 1.0591L7.05265 0.708978L6.70024 1.0591L1.07769 6.64525L0.720682 6.99995L1.07769 7.35465L6.70024 12.9408L7.05265 13.2909L7.40505 12.9408L13.0276 7.35465L13.3846 6.99995L13.0276 6.64525L7.40505 1.0591ZM2.13951 6.99995L7.05265 2.11862L11.9658 6.99995L7.05265 11.8813L2.13951 6.99995ZM7.05265 0.704333L13.3893 6.99995L7.05265 13.2956L0.716006 6.99995L7.05265 0.704333Z",
    fill: "#FF832B",
    stroke: "#BA4E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinorStatus);
export default __webpack_public_path__ + "static/media/minor_status.f956b997ddbdea3c7bb01b623cf95118.svg";
export { ForwardRef as ReactComponent };